const command = state => state.command
const commands = state => state.commands

export default {
  command,
  commands
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/commands/getters.js